<template>
  <div>
    <h1>{{ t('title') }}</h1>
    <p>{{ t('welcome') }}</p>
  </div>
</template>

<script setup lang="ts">
import { Role } from '@/opendoors-api/client'
import { useI18n } from 'vue-i18n'
definePage({
  name: 'dashboard',
  meta: { requiredRoles: [Role.ADMIN, Role.CUSTOMER, Role.DEURGETEST] }
})

const { t } = useI18n()
</script>

<i18n lang="yaml">
en:
  title: 'dashboard'
  welcome: 'welcome to the dashboard page'
nl:
  title: 'dashboard'
  welcome: 'welkom op de dashboard pagina'
de:
  title: 'dashboard'
  welcome: 'willkommen auf der dashboard seite'
</i18n>
